module.exports = __webpack_public_path__ + "img/toplotna-pumpa.4684de61.png";